import UAParser from 'ua-parser-js';
import { Device, type DeviceType, Platform } from '@weberus/shared-types';

/**
 * UA parser를 이용해 user-agent를 분류하는 함수
 */
export const getOS = (userAgent: string): (typeof Device)[keyof typeof Device] => {
  const uaParser = new UAParser(userAgent);
  const os = uaParser.getOS();
  if (os.name?.toLowerCase() === 'android') {
    return Device.android;
  }

  if (os.name === 'iOS') {
    return Device.ios;
  }

  return Device.etc;
};

/**
 * NOL API headers 정보에 필요한 device platform 정보
 */
export function getNolPlatformFromUserAgent(userAgent?: string): 'Android' | 'iOS' | 'MWeb' | 'Web' {
  const ua = new UAParser(userAgent).getResult();

  // App OS 여부
  const isApp = ['Android', 'iOS'].includes(ua.os.name || '');

  // 모바일 기기(휴대폰, 태블릿) 여부
  const isMobileDevice = ua.device.type === 'mobile' || ua.device.type === 'tablet';
  // eslint-disable-next-line no-nested-ternary
  return isApp ? (ua.os.name as 'Android' | 'iOS') : isMobileDevice ? 'MWeb' : 'Web';
}

export const getPlatform = (appDevice?: DeviceType | null, deviceType?: string | null) => {
  if (appDevice === Device.android) return Platform.ANDROID;
  if (appDevice === Device.ios) return Platform.IOS;
  return deviceType === Device.ios || deviceType === Device.android ? Platform.MWeb : Platform.Web;
};

export { UAParser };
